import { useState } from "react";
import {
  List,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Collapse,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddToDriveIcon from '@mui/icons-material/AddToDrive';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import WebhookIcon from '@mui/icons-material/Webhook';
import HubIcon from '@mui/icons-material/Hub';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import TimelineIcon from '@mui/icons-material/Timeline';
import EmailIcon from '@mui/icons-material/Email';
import TabletIcon from '@mui/icons-material/Tablet';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { useTenant } from '../context/TenantContext';

export default function EmpowerCareNetwork({ selectedView, setSelectedView }) {
  const [open, setOpen] = useState(true);
  const { tenant } = useTenant();

  // Get the brand name to display
  const brandName = tenant?.brandName || tenant?.name || 'Super Admin';
  // Get primary color for styling
  const primaryColor = tenant?.primaryColor || '#06AB8B';

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <List component="nav" style={{ padding: 0, cursor: "pointer" }}>
      {/* Main Option */}
      <ListItemButton
        onClick={handleToggle}
        style={{
          backgroundColor: "#F5FAF9",
          borderLeft: `8px solid ${primaryColor}`,
          borderRadius: "0px",
          padding: "10px 16px",
          color: primaryColor,
          minHeight: 60,
          marginBottom: "15px",
        }}
      >

        <ListItemText
          primary={brandName}
          primaryTypographyProps={{
            style: { fontWeight: 500, color: primaryColor },
          }}
        />
        {open ? (
          <ExpandLess style={{ color: primaryColor }} />
        ) : (
          <ExpandMore style={{ color: primaryColor }} />
        )}
      </ListItemButton>

      {/* Dropdown */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

            {/* Dashboard */}
          <ListItemButton
            onClick={() => setSelectedView("dashboard")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "dashboard" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "dashboard" ? <CheckCircleIcon /> : <DashboardIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

            {/* Patients */}
          <ListItemButton
            onClick={() => setSelectedView("patients")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "patients" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "patients" ? <CheckCircleIcon /> : <PeopleIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Patients"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

            {/* Show Admin List */}
          <ListItemButton
            onClick={() => setSelectedView("admin-list")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "admin-list" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "admin-list" ? <CheckCircleIcon /> : <AdminPanelSettingsIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Admin Lists"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* Update Google drive */}
          <ListItemButton
            onClick={() => setSelectedView("update-google-drive")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "update-google-drive" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "update-google-drive" ? <CheckCircleIcon /> : <AddToDriveIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Update Google Drive"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* OpenAI API Key */}
          <ListItemButton
            onClick={() => setSelectedView("update-api-key")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "update-api-key" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "update-api-key" ? <CheckCircleIcon /> : <VpnKeyIcon />}
            </ListItemIcon>
            <ListItemText
              primary="OpenAI API Key"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* Resend Email Key */}
          <ListItemButton
            onClick={() => setSelectedView("update-resend-key")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "update-resend-key" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "update-resend-key" ? <CheckCircleIcon /> : <EmailIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Resend Email Key"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* Update prompt */}
          <ListItemButton
            onClick={() => setSelectedView("update-prompt")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "update-prompt" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "update-prompt" ? <CheckCircleIcon /> : <AutoAwesomeIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Update Prompt"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* GHL Connection */}
          <ListItemButton
            onClick={() => setSelectedView("ghl-connection")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "ghl-connection" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "ghl-connection" ? <CheckCircleIcon /> : <HubIcon />}
            </ListItemIcon>
            <ListItemText
              primary="GHL Connection"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

              {/* Update Webhooks */}
          <ListItemButton
            onClick={() => setSelectedView("update-webhooks")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "update-webhooks" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "update-webhooks" ? <CheckCircleIcon /> : <WebhookIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Update Webhooks"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* GHL Custom Fields */}
          <ListItemButton
            onClick={() => setSelectedView("ghl-custom-fields")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "ghl-custom-fields" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "ghl-custom-fields" ? <CheckCircleIcon /> : <TextFieldsIcon />}
            </ListItemIcon>
            <ListItemText
              primary="GHL Custom Fields"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* Kiosk Management */}
          <ListItemButton
            onClick={() => setSelectedView("kiosk-management")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "kiosk-management" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: primaryColor, minWidth: "35px" }}>
              {selectedView === "kiosk-management" ? <CheckCircleIcon /> : <TabletIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Kiosk Management"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: primaryColor },
              }}
            />
          </ListItemButton>

          {/* Pending Follow-ups */}
          <ListItemButton
            onClick={() => setSelectedView("pending-followups")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "pending-followups" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: "#d97706", minWidth: "35px" }}>
              {selectedView === "pending-followups" ? <CheckCircleIcon /> : <PendingActionsIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Pending Follow-ups"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: "#d97706" },
              }}
            />
          </ListItemButton>

          {/* Locked Users */}
          <ListItemButton
            onClick={() => setSelectedView("locked-users")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "locked-users" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: "#dc2626", minWidth: "35px" }}>
              {selectedView === "locked-users" ? <CheckCircleIcon /> : <LockPersonIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Locked Users"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: "#dc2626" },
              }}
            />
          </ListItemButton>

          {/* Activity Logs */}
          <ListItemButton
            onClick={() => setSelectedView("activity-logs")}
            style={{
              paddingLeft: 24,
              backgroundColor: selectedView === "activity-logs" ? "#F5FAF9" : "#fff",
              borderRadius: "0px 10px 10px 0px",
              marginBottom: "8px",
            }}
          >
            <ListItemIcon style={{ color: "#7c3aed", minWidth: "35px" }}>
              {selectedView === "activity-logs" ? <CheckCircleIcon /> : <TimelineIcon />}
            </ListItemIcon>
            <ListItemText
              primary="Activity Logs"
              primaryTypographyProps={{
                style: { fontWeight: 500, color: "#7c3aed" },
              }}
            />
          </ListItemButton>

        </List>
      </Collapse>
    </List>
  );
}
